import { transportRequest } from '@krp/client-runtime'

import type { OwnDispatch } from '../../../state'
import { decodeCashierChoices, decodePosGrant, decodeSignIn, type PosCashierChoice, type PosCashierGrant, type PosSignIn } from '../model/cashier'
import { OWN_POS_CASHIER_URLS } from './urls'

/** Исход вызова службы Cashiers: данные или ошибка транспорта как есть (слова сервера дословно, код, номер запроса). */
export type CashierCall<T> = { ok: true; data: T } | { ok: false; error: unknown }

/** Граница с Cashiers. Окно получает её снаружи, поэтому проверяется без сети; код кассира есть только в аргументе `verify`. */
export interface OwnCashierApi {
  list: (resourceId: string) => Promise<CashierCall<readonly PosCashierChoice[]>>
  /** Вход без повторов: код выбранного кассира → билет → пропуск `pos` на его кассира источника; выдаётся на нажатие человека. */
  verify: (input: { resourceId: string; cashierId: string; sourceCashierId: string; credential: string }) => Promise<CashierCall<PosCashierGrant>>
}

/** Вызовы через `transport` стора (CSRF, корреляция, разбор отказа); вход и пропуск — с `noRetry`. */
export function createOwnCashierApi(dispatch: OwnDispatch): OwnCashierApi {
  return {
    list: (resourceId) =>
      dispatch(transportRequest<readonly PosCashierChoice[]>({ url: OWN_POS_CASHIER_URLS.list, params: { resourceId }, decode: decodeCashierChoices })),
    verify: async ({ resourceId, cashierId, sourceCashierId, credential }) => {
      const signed = await dispatch(
        transportRequest<PosSignIn>({ url: OWN_POS_CASHIER_URLS.signIn, method: 'POST', body: { code: credential, cashierId }, noRetry: true, decode: decodeSignIn }),
      )
      if (!signed.ok) return signed
      // Пропуск просят ровно на ту связь, которую выбрали в списке; если службы её не отдали — права работать здесь на кассе нет.
      const place = signed.data.workplaces.find(
        (item) => item.resourceId.toLowerCase() === resourceId.toLowerCase() && item.sourceCashierId.toLowerCase() === sourceCashierId.toLowerCase(),
      )
      if (place === undefined) {
        return { ok: false, error: new Error('Кассир не связан с кассиром этой кассы или у вас нет права работать здесь на кассе. Обратитесь к администратору: вкладка «Кассиры».') }
      }
      return dispatch(
        transportRequest<PosCashierGrant>({
          url: OWN_POS_CASHIER_URLS.grant,
          method: 'POST',
          body: { ticket: signed.data.ticket, resourceId, sourceCashierId: place.sourceCashierId },
          noRetry: true,
          decode: decodePosGrant,
        }),
      )
    },
  }
}
